import { render, staticRenderFns } from "./AlertWidget.vue?vue&type=template&id=04d9f80a&"
import script from "./AlertWidget.vue?vue&type=script&lang=js&"
export * from "./AlertWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports